import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe implements PipeTransform {

  private readonly suffixes = [
    '',
    'K',
    'M',
    'B',
    'T'
  ];

  transform(value: number, decimals = 1): string {
    if (isNaN(value) || value === 0) {
      return '0'; // Handle zero or invalid values gracefully
    }

    const exponent = Math.floor(Math.log(Math.abs(value)) / Math.log(1000));
    const adjustedValue = value / Math.pow(1000, exponent);

    // Ensure at least 1 decimal place is shown, even for very small numbers
    const formattedValue = adjustedValue.toFixed(Math.max(decimals, 1));

    const suffix = this.suffixes[exponent] || '';
    return `${formattedValue}${suffix}`;
  }
}
